
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic15 as ObiHydraulic15Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-15.js';
 
 
 

 
 export const ObiHydraulic15 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-15',
   elementClass: ObiHydraulic15Element,
   events: {
     
   }
  });
 
 